// loaders.gl, MIT license

import * as WorkerThreads from 'worker_threads';
export * from 'worker_threads';
export const NodeWorker = WorkerThreads.Worker;
export type NodeWorkerType = WorkerThreads.Worker;
